import { render, staticRenderFns } from "./ChangesHistoryTable.vue?vue&type=template&id=2c00dc16&scoped=true"
import script from "./ChangesHistoryTable.vue?vue&type=script&lang=js"
export * from "./ChangesHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./ChangesHistoryTable.vue?vue&type=style&index=0&id=2c00dc16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00dc16",
  null
  
)

export default component.exports